module.exports = __webpack_public_path__ + "ab06ce577d582e3500685ce822adffc4.svg";